export default function findProductSelection(styles, itemId, itemOptionId, coliItemsCount) {
    let selectedItem = null;
    let selectedStyle = null;
    let selectedItemOption = null;

    if (itemId) {
        // 1. Item und style finden, da style nicht über styleId gefunden werden kann
        const selection = findSelection(styles, itemId);
        if (selection) {
            selectedStyle = selection.selectedStyle;
            selectedItem = selection.selectedItem;
        }

        // 2. Danach ItemOption finden, wenn kein coli Artikel und mehrere Artikel verfügbar sind
        if (selectedItem?.itemOptions) {
            selectedItemOption = findSelectedItemOption(selectedItem, itemOptionId, coliItemsCount);
        }
    }

    return {
        selectedStyle,
        selectedItem,
        selectedItemOption
    };
}

function findSelection(styles, itemId) {
    for (let i = 0; i < styles.length; i++) {
        const style = styles[i];
        const items = style.items;
        for (let j = 0; j < items.length; j++) {
            const item = items[j];
            if (item.id === +itemId) {
                return {
                    selectedItem: item,
                    selectedStyle: style
                };
            }
        }
    }

    // Fallback, um den Layer trotzdem öffnen zu können, wenn aktuell im Warenkorb ausgewähle Farbe
    // komplett ausverkauft ist und somit nicht vom ProductService ausgeliefert wird
    return {
        selectedItem: styles[0]?.items[0],
        selectedStyle: styles[0]
    };
}

function findSelectedItemOption(selectedItem, itemOptionId, coliItemsCount) {
    if (coliItemsCount || selectedItem.itemOptions.length === 1) {
        return selectedItem.itemOptions[0];
    } else if (itemOptionId) {
        const itemOptions = selectedItem.itemOptions;
        for (let i = 0; i < itemOptions.length; i++) {
            const itemOption = itemOptions[i];
            if (itemOption.id === +itemOptionId) {
                return itemOption;
            }
        }
    }
    return null;
}
